import React, { useState } from "react";
import "./stylesheets/home.css";
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
} from "@chakra-ui/react";

const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [active, setActive] = useState({
    home: true,
    about: false,
    work: false,
    skills: false,
    contact: false,
  });
  const downloadResume = async () => {
    const serverUrl =
      "https://jksingh-portfolio-server.vercel.app/api/downloadFile";

    try {
      const response = await fetch(serverUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "jyoti_kamal_resume.pdf"; // Specify desired file name for download
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      const driveLink =
        "https://drive.google.com/file/d/14-q-LT3KKqW2LIt2Yfg-mkcs_9QHN6Ul/view";
      window.open(driveLink, "_blank"); // Open the drive link in a new tab/window
    } catch (error) {
      console.error("Error downloading file:", error);
      // Handle any errors that occur during the download
    }
  };

  return (
    <>
      <div id="navbar" data-aos="fade-in">
        <div>
          <a href="#home">
            <h1>
              JYOTI <span style={{ color: "#dc143c" }}>KAMAL</span>
            </h1>
          </a>
        </div>

        <div>
          <a
            onClick={() =>
              setActive({
                ...active,
                home: true,
                about: false,
                work: false,
                skills: false,
                contact: false,
              })
            }
            className={active.home ? "active" : ""}
            href="#home"
          >
            <div>HOME</div>
          </a>
          <a
            onClick={() =>
              setActive({
                ...active,
                home: false,
                about: true,
                work: false,
                skills: false,
                contact: false,
              })
            }
            className={active.about ? "active" : ""}
            href="#about"
          >
            <div>ABOUT</div>
          </a>
          <a
            onClick={() =>
              setActive({
                ...active,
                home: false,
                about: false,
                work: true,
                skills: false,
                contact: false,
              })
            }
            className={active.work ? "active" : ""}
            href="#work"
          >
            <div>WORK</div>
          </a>
          <a
            onClick={() =>
              setActive({
                ...active,
                home: false,
                about: false,
                work: false,
                skills: true,
                contact: false,
              })
            }
            className={active.skills ? "active" : ""}
            href="#skills"
          >
            <div>SKILLS</div>
          </a>
          <a
            onClick={() =>
              setActive({
                ...active,
                home: false,
                about: false,
                work: false,
                skills: false,
                contact: true,
              })
            }
            className={active.contact ? "active" : ""}
            href="#contact"
          >
            <div>CONTACT</div>
          </a>
          <a onClick={downloadResume} style={{ cursor: "pointer" }}>
            <div>RESUME</div>
          </a>
        </div>
      </div>
      <div>
        <span
          onClick={onOpen}
          style={{ fontSize: "30px", cursor: "pointer" }}
          className="material-icons"
        >
          menu
        </span>
      </div>
      <Drawer size="md" placement={"right"} onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton marginTop="12px" />
          <DrawerHeader
            cursor="pointer"
            onClick={onClose}
            backgroundColor="#edf2f8"
            fontSize="26px"
            borderBottomWidth="1px"
          >
            Explore The Page
          </DrawerHeader>
          <DrawerBody id="drawer" backgroundColor="#edf2f8">
            <a onClick={onClose} href="#home">
              <h1 style={{ padding: "10px", fontSize: "24px" }}>Home</h1>
            </a>
            <a onClick={onClose} href="#about">
              <h1 style={{ padding: "10px", fontSize: "24px" }}>About</h1>
            </a>
            <a onClick={onClose} href="#work">
              <h1 style={{ padding: "10px", fontSize: "24px" }}>Work</h1>
            </a>
            <a onClick={onClose} href="#skills">
              <h1 style={{ padding: "10px", fontSize: "24px" }}>Skills</h1>
            </a>
            <a onClick={onClose} href="#contact">
              <h1 style={{ padding: "10px", fontSize: "24px" }}>Contact</h1>
            </a>
            <a
              onClick={() => {
                downloadResume();
                onClose();
              }}
            >
              <h1 style={{ padding: "10px", fontSize: "24px" }}>Resume</h1>
            </a>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Navbar;
